import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Lecture } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update course lecture
 * @param course_id
 * @param version
 * @param sectionId
 * @param lectureId
 * @param title
 * @param preview
 */
const updateCourseLecture = (
  course_id: string,
  version: number,
  sectionId: string,
  lectureId: string,
  title: string,
  preview: boolean,
  deprecated?: boolean
): Promise<Lecture> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures/' +
      lectureId
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data =
      deprecated === undefined
        ? { title, preview }
        : { title, preview, deprecated }

    AxiosClient.patch(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCourseLecture
